import React, { useState, useEffect } from "react";
import Icon from "../../components/ui/icon";
import { useToast } from "../../context/toastContext";
import { useNavigate } from "react-router-dom";
import api from "../../services/apiClient";
import AdminSideNav from "../../components/layout/adminSideNav";
import NotAuthorizedMessage from "../../components/feedback/notAuthorizedMessage";

const AdminPostbackPage = () => {
  const navigate = useNavigate();
  const showToast = useToast();
  const [isSideNavActive, setisSideNavActive] = useState(false);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("AdminInfo")) || {}
  );
  const [postbackURL, setpostbackURL] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("aToken");
    if (!token) {
      navigate("/auth/login");
      return;
    }

    api
      .get(`/api/admin/info`)
      .then((response) => {
        setUserInfo(response.data.data);
        localStorage.setItem("AdminInfo", JSON.stringify(response.data.data));
        if (response?.data?.data?.postback)
          setpostbackURL(response.data.data.postback);
      })
      .catch((err) => {
        showToast({
          status: "error",
          message: err.response?.data?.message || "Login not found.",
        });
        navigate("/auth/login");
      });
  }, [navigate, showToast]);

  const handelCopyPostbackLink = () => {
    if (!postbackURL) return;
    navigator.clipboard.writeText(postbackURL);
    showToast({
      status: "success",
      message: "Copied to clipboard.",
    });
  }

  return (
    <div className="postback__page">
      <AdminSideNav
        userName={userInfo.name}
        emailID={userInfo.email}
        active={isSideNavActive}
      />
      <div
        onClick={() => setisSideNavActive(!isSideNavActive)}
        className={
          isSideNavActive ? "background-shadow active" : "background-shadow"
        }
      ></div>
      <main>
        <header className="desktop-header">
          <div>
            <h2>Postback</h2>
            <p>Get information about conversion postback.</p>
          </div>
        </header>

        <header className="mobile-header">
          <div>
            <h2>Postback</h2>
          </div>
          <button
            className="nav-btn"
            onClick={() => setisSideNavActive(!isSideNavActive)}
          >
            {isSideNavActive ? (
              <Icon name="XMark" className="onLeft" />
            ) : (
              <Icon name="Bars3" className="onLeft" />
            )}
          </button>
        </header>

        {userInfo && userInfo.role !== "admin" && (
          <NotAuthorizedMessage />
        )}

        <div className="main-container">
          <section className="card postback-editor">
            <div className="card-header">
              <div>
                <h3>Generated Postback URL</h3>
                <p className="card-subtitle">
                  Use this URL in your system to receive conversion callbacks.
                </p>
              </div>

              <span className="badge">Read Only</span>
            </div>

            <textarea
              placeholder="Enter your global postback here."
              rows="4"
              value={postbackURL}
              readOnly
              id="postbackUrl"
            ></textarea>

            <div className="editor-actions">
              <button onClick={handelCopyPostbackLink} className="primary">
                Copy URL
                <Icon name="DocumentDuplicate" />
              </button>
            </div>
          </section>

          <section className="card placeholders-card">
            <h3>Postback Parameters</h3>
            <p className="card-subtitle">
              These parameters are dynamically replaced when a conversion is tracked.
            </p>

            <div className="placeholders-grid">
              <div className="placeholder-pill">
                <code>{`{clickId}`}</code>
                <span>Actual click identifier</span>
              </div>

              <div className="placeholder-pill">
                <code>{`{goal}`}</code>
                <span>Goal of the campaign</span>
              </div>
            </div>
          </section>
        </div>

        <span className="copyright-text">
          © 2025 Swift Digital Ads, All rights reserved
        </span>
      </main>
    </div>
  );
};

export default AdminPostbackPage;
